import { MenuItem } from "@blueprintjs/core";
import { ItemRenderer } from "@blueprintjs/select";
import {
  CustomerOrder_State,
  CustomerOrder_Type,
  Distributor,
} from "../../api/schema";
import { UserLanguage } from "../../lang/lang";
import {
  IconMapperStateIntent,
  IconMapperTypeIntent,
} from "../../views/Store/CustomerOrder/helper";

const CustomerOrder_State_renderer: ItemRenderer<CustomerOrder_State> = (
  item,
  { modifiers, handleClick }
) => {
  return (
    <MenuItem
      key={item}
      active={modifiers.active}
      style={{ minWidth: 100 }}
      text={UserLanguage().data.customerOrder.states[item]}
      onClick={handleClick}
      intent={IconMapperStateIntent[item]}
    />
  );
};

const CustomerOrder_Type_renderer: ItemRenderer<CustomerOrder_Type> = (
  item,
  { modifiers, handleClick }
) => {
  return (
    <MenuItem
      active={modifiers.active}
      style={{ minWidth: 100 }}
      text={UserLanguage().data.customerOrder.types[item]}
      onClick={handleClick}
      intent={IconMapperTypeIntent[item]}
    />
  );
};

const Distributor_ShortName_renderer: ItemRenderer<Distributor> = (
  item,
  { modifiers, handleClick }
) => {
  return (
    <MenuItem
      key={item.id + "_select"}
      active={modifiers.active}
      style={{ minWidth: 100 }}
      text={item.short_name || item.name}
      onClick={handleClick}
    />
  );
};

export const ItemRenderers = {
  CustomerOrder_State: CustomerOrder_State_renderer,
  CustomerOrder_Type: CustomerOrder_Type_renderer,
  Distributor_ShortName: Distributor_ShortName_renderer,
};
